import * as React from 'react'
import './styles.scss'
import { BlazeButton } from '../CustomButtons/BlazeButton'

export interface ButtonProps {
  onClick: () => void
  title: string
  isSaving?: boolean
  style?: React.CSSProperties
  disabled?: boolean
}

export const SaveButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  return (
    <BlazeButton
      buttonProps={{
        type: 'primary',
        style: props.style,
        disabled: props.isSaving || props.disabled,
        loading: props.isSaving,
        onClick: (e) => {
          e.preventDefault()
          props.onClick()
        },
      }}
      titleProps={{
        title: props.title,
      }}
    />
  )
}
